export const getOffsetTop = (element) => (element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0);
